#!/usr/bin/env node

process.stdin.pipe(process.stdout);
